import { faqItems } from '@/mocks/baoliao';

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            关于爆料专区的常见疑问与解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <details
              key={item.id}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              open
            >
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <h3 className="font-medium text-foreground-900 text-sm md:text-base pr-4">
                  {item.question}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-foreground-600 group-open:text-primary-600 transition-transform group-open:rotate-180 text-sm"></i>
                </span>
              </summary>
              <div className="px-5 pb-5 -mt-1">
                <p className="text-foreground-600 text-sm leading-relaxed">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}